import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { GetChannelsResponse } from '@hud/portal-dtos/channels.dtos';

export const CHANNELS_KEY = 'channels';

export default function useChannels(slackIntegrationReady: boolean) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [CHANNELS_KEY],
    queryFn: async () => {
      const response = await client.get<GetChannelsResponse>(`/channels`);
      return GetChannelsResponse.parse(response.data);
    },
    enabled: isReady && slackIntegrationReady,
  });
}
